import { render, staticRenderFns } from "./DeleteTopic.vue?vue&type=template&id=51ec8c88&"
import script from "./DeleteTopic.vue?vue&type=script&lang=js&"
export * from "./DeleteTopic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports